import React from "react";
import CloseImg from "images/ic_close.svg";

const CloseIcon = () => {
  return <img src={CloseImg} alt="close" className="cursor-pointer" />;
};

export default CloseIcon;
